import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'hx-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer>
      <div class="wrap">
        <div class="footer-top">
          <div class="footer-brand">
            <a routerLink="/" class="brand">
              <span class="brand-mark" aria-hidden="true"></span>
              Hexacorp
            </a>
            <p>Cloud infrastructure, payment systems, and custom software — built and supported by one team.</p>
          </div>
          <div class="footer-cols">
            <div class="footer-col">
              <h5>Site</h5>
              <a href="/#solutions">Solutions</a>
              <a href="/#work">Work</a>
              <a href="/#process">Process</a>
              <a routerLink="/promotions">Promotions</a>
            </div>
            <div class="footer-col">
              <h5>Company</h5>
              <a href="/#contact">Contact</a>
              <span>hexacorp.xyz</span>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <span>© 2026 Hexacorp I.T. Solutions. All rights reserved.</span>
          <span>Manila, Philippines</span>
        </div>
      </div>
    </footer>
  `,
})
export class FooterComponent {}
